@if (resolvedModel$ | async; as model) { @if (storageVariant$ | async; as variant) { @if (variant === 2) {
<app-grid-registration-form-storage-v2 [originalModel]="model" />
} @else if (variant === 1) {
<app-grid-registration-form-consumer [originalModel]="model" />
} } }
